import { render, staticRenderFns } from "./documentOption.vue?vue&type=template&id=0e4f92fc&"
import script from "./documentOption.vue?vue&type=script&lang=js&"
export * from "./documentOption.vue?vue&type=script&lang=js&"
import style0 from "./documentOption.vue?vue&type=style&index=0&id=0e4f92fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports